import {H2, PNoMargin} from '@/typography';
import {Row, Col} from '@/grid';
import {withMarginBottomXxl, withMarginBottomZeroToLg} from '@/hocs/withSpacing';
import {withGreen200, withNeutral50} from '@/hocs/withColors';
import {withBoldWeight} from '@/hocs/withFontType';
import withBreakpoints from '@/hocs/withBreakpoints';
import PictureWrapper from '@/ui/images-wrapper';
import styles from './styles.module.scss';

const StatisticText = withBoldWeight(withMarginBottomZeroToLg(withNeutral50(PNoMargin)));
const GreenH2 = withGreen200(H2);
const DivSpace = withMarginBottomXxl('div');

const imgPath = '/static/images/home/';

const ResponsiveCompaniesLogos = withBreakpoints({
  desktop: props => (
    <PictureWrapper
      imgPath={imgPath}
      imageUrl="logos-desktop"
      imageTypeFallback="png"
      altImage="Companies logos graphic"
    />
  ),
  mobile: props => (
    <PictureWrapper
      imgPath={imgPath}
      imageUrl="logos-mob"
      imageTypeFallback="png"
      altImage="Companies logos graphic"
    />
  )
});

const CompanyStats = () => (
  <>
    <DivSpace>
      <Row center="xs" className={styles.gap100}>
        <Col xs={12} md={4} lg>
          <GreenH2>35,000+</GreenH2>
          <StatisticText>companies</StatisticText>
        </Col>
        <Col xs={6} md={4} lg>
          <GreenH2>400M</GreenH2>
          <StatisticText>people</StatisticText>
        </Col>
        <Col xs={6} md={4} lg>
          <GreenH2>2.1M</GreenH2>
          <StatisticText>hires</StatisticText>
        </Col>
        <Col xs={6} md={4} lg>
          <GreenH2>100+</GreenH2>
          <StatisticText>countries</StatisticText>
        </Col>
        <Col xs={6} md={4} lg>
          <GreenH2>98%</GreenH2>
          <StatisticText>satisfaction</StatisticText>
        </Col>
      </Row>
    </DivSpace>

    <DivSpace>
      <ResponsiveCompaniesLogos />
    </DivSpace>
  </>
);

export default CompanyStats;
